import type { ReactionResponse } from '@trello/realtime-updater';

import type { AddReactionMutation } from './AddReactionMutation.generated';
import { convertSkinToEmojiMartFormat } from './convertSkinToEmojiMartFormat';
import type { ReactionModel } from './Reactions.types';

type AddReactionResponse = AddReactionMutation['addReaction'];

export const convertReactionToClientFormat = ({
  id,
  idEmoji,
  idMember,
  idModel,
  member,
  emoji,
}: AddReactionResponse | ReactionResponse): ReactionModel => ({
  id,
  idEmoji: idEmoji.toUpperCase(),
  idMember,
  idModel,
  emoji: {
    id: emoji.shortName.toUpperCase(),
    name: emoji.name ?? '',
    shortcodes: `:${emoji.shortName}${
      emoji.skinVariation
        ? `::skin-tone-${convertSkinToEmojiMartFormat(emoji.skinVariation)}`
        : ''
    }:`,
    unified: emoji.unified,
    skin: emoji.skinVariation
      ? convertSkinToEmojiMartFormat(emoji.skinVariation)
      : undefined,
    native: emoji.native,
  },
  member: {
    id: member.id,
    fullName: member.fullName ?? undefined,
  },
});
